const enum Blue {
  Blue10 = '#F6FBFF',
  Blue20 = '#E6F3FF',
  Blue30 = '#CEE8FF',
  Blue40 = '#8ECFFF',
  Blue50 = '#4FAFFF',
  Blue60 = '#008BFF',
  Blue70 = '#057AED',
  Blue80 = '#1068D9',
  Blue90 = '#0F55C7',
  Blue100 = '#1141A8'
}

const enum Green {
  Green80 = '#00D58C'
}

const enum Gray {
  Gray10 = '#FAFAFC',
  Gray20 = '#F5F6FA',
  Gray30 = '#E5E7EC',
  Gray40 = '#CBCFD7',
  Gray50 = '#ACB2C0',
  Gray60 = '#828896',
  Gray70 = '#5E6472',
  Gray80 = '#424958',
  Gray90 = '#303642',
  Gray100 = '#111723'
}

const enum SkyBlue {
  SkyBlue20 = '#E3FEFF',
  SkyBlue60 = '#E3FEFF'
}

const enum Red {
  Red10 = '#FFF8F8',
  Red20 = '#FFEBEB',
  Red50 = '#FF7575',
  Red60 = '#FF4E4E'
}

const enum Yellow {
  Yellow100 = '#FFEE5A'
}

const enum White {
  White10 = '#FFFFFF',
  White10Alpha15 = '#FFFFFF26',
  White10Alpha50 = '#FFFFFF80',
  White10Alpha55 = '#FFFFFF8C',
  White10Alpha60 = '#FFFFFF99',
  White10Alpha70 = '#FFFFFFB3',
  White10Alpha80 = '#FFFFFF80'
}

const enum Black {
  Black10 = '#000000'
}

const enum PaleGreen {
  PaleGreen20 = '#E6FEFA',
  PaleGreen40 = '#76E3D0',
  PaleGreen50 = '#B2F1E6'
}

const enum PaleNavy {
  PaleNavy40 = '#BCCDE4'
}

const enum PaleBeige {
  PaleBeige40 = '#EFE4BE'
}

const enum GoodocBlue {
  GoodocBlue10 = Blue.Blue10,
  GoodocBlue20 = Blue.Blue20,
  GoodocBlue30 = Blue.Blue30,
  GoodocBlue40 = Blue.Blue40,
  GoodocBlue50 = Blue.Blue50,
  GoodocBlue60 = Blue.Blue60,
  GoodocBlue70 = Blue.Blue70,
  GoodocBlue80 = Blue.Blue80,
  GoodocBlue90 = Blue.Blue90,
  GoodocBlue100 = Blue.Blue100
}

const enum Primary {
  White10 = White.White10,
  GoodocBlue10 = GoodocBlue.GoodocBlue10,
  GoodocBlue60 = GoodocBlue.GoodocBlue60
}

const enum Main {
  priBlue = '#0073FA',
  red = '#FF0000',
  green = '#00D58C',
  kakao = '#FAE300'
}

const enum Pink {
  Default = '#FF699F'
}

const enum Kakao {
  Default = '#FEE500'
}

const enum Payment {
  Default = '#121212',
  Hyundai = '#E5E7EC',
  Kookmin = '#FFD440',
  Hana = '#02AB67',
  Shinhan = '#008BFF',
  Samsung = '#3C82FF',
  Woori = '#1A9ED8',
  BC = '#ED6A5E'
}

export {
  Primary,
  GoodocBlue,
  Blue,
  Green,
  Gray,
  SkyBlue,
  Red,
  Yellow,
  White,
  Black,
  PaleGreen,
  PaleNavy,
  PaleBeige,
  Pink,
  Kakao,
  Payment,
  Main
};
